import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, isEmpty } from "../../../Schema";
import { yesNoBooleanOptions } from "../../common";
import { checkInWithoutBooking } from "./checkInValidation";

export const checkInRequired: FieldSchema = {
  grid: {
    displayed: true,
    order: 70,
    ignoredForSearch: true,
  },
  name: "checkInRequired",
  data: {
    variant: DataVariants.ENUM,
    options: yesNoBooleanOptions,
    assignedValue: {
      getter: ({ checkInRequired, isBookable }) =>
        !isBookable ? EMPTY_VALUE : isEmpty(checkInRequired) ? false : checkInRequired,
      fields: ["isBookable"],
    },
  },
  dataTransform: {
    // A non-bookable equipment has no booking behaviour to record, so the stored value
    // is cleared rather than left behind to contradict isBookable.
    toDb: {
      getter: ({ isBookable, checkInRequired }) =>
        isBookable === false ? EMPTY_VALUE : checkInRequired,
      fields: ["isBookable", "checkInRequired"],
    },
  },
  display: {
    displayed: true,
  },
  validation: {
    required: {
      getter: ({ isBookable }) => isBookable === true,
      fields: ["isBookable"],
    },
    custom: checkInWithoutBooking,
  },
  form: {
    label: "Requires check in",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ isBookable }) => isBookable !== true,
      fields: ["isBookable"],
    },
  },
};
